
import { defineComponent } from 'vue';
import { mapActions, mapGetters } from 'vuex';
// import { Position } from '@/views/interfaces/entities.ts';


export default defineComponent({
    name: 'match-card',
    computed: {
      ...mapGetters({
        tournament: 'tournament/getTournament',
        match: 'tournament/getMatch',
      }),
    },
    methods: {
      ...mapActions({
          vote: 'tournament/vote',
      }),

    }
});

 